const documents = {
    privacy: '/pdf/politika-zasebnosti.pdf',
    terms: '/pdf/splosni-pogoji.pdf',
    photoContestRules: '/pdf/pravila-foto-natecaj.pdf'
};

export default documents;
